import { render } from "./PartGrade.vue?vue&type=template&id=4d471bfe&scoped=true&ts=true&lang=pug"
import script from "./PartGrade.vue?vue&type=script&lang=ts"
export * from "./PartGrade.vue?vue&type=script&lang=ts"

import "./PartGrade.vue?vue&type=style&index=0&id=4d471bfe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d471bfe"]])

export default __exports__